import { AtImageVariant } from './index'

const atImageVariants: Record<AtImageVariant, string> = {
  none: '',
  background: 'absolute inset-0 h-full w-full object-cover',
  'banner-logo': 'w-full h-full inset-0 relative',
  cover: 'h-full w-full object-cover',
}

export const getAtImageVariant = (variant: AtImageVariant) => {
  return atImageVariants[variant] ?? ''
}
